import { ToastCustom } from "@components";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "sonner";
import { importExpensesHeader } from "../services";
import type { ExpenseImportHeaderResponse } from "../types";

export function useImportExpensesHeader() {
	return useMutation<
		ExpenseImportHeaderResponse,
		AxiosError<{ message?: string }>,
		{ type: number; file: File }
	>({
		mutationFn: ({ type, file }) => importExpensesHeader(type, file),
		onError: (error) => {
			const message =
				error.response?.data?.message ??
				"Erro ao ler cabeçalho da planilha de despesas.";

			toast(
				ToastCustom({
					description: message,
					title: "Erro na importação",
					variant: "error",
				})
			);
		},
	});
}
